import { addDays, DateOnly } from '@if/core/date'
import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'

export const MIN_LOAN_AMOUNT = 500
export const MERCHANT_FEE_RATE_MIN = 0.005
export const MERCHANT_FEE_RATE_MAX = 0.3

export const customBuydownSchema = () =>
  yup.object({
    contribution: yup.percent().required().min(MERCHANT_FEE_RATE_MIN).max(MERCHANT_FEE_RATE_MAX),
    activeFrom: yup.dateOnly().required().min(addDays(DateOnly.today(), 1)),
    expiresOn: yup.dateOnly().defined().nullable().min(yup.ref('activeFrom'), { offsetDays: 1 }),

    maxFinancingAmount: yup
      .number()
      .min(MIN_LOAN_AMOUNT, () => t('customBuydown.errors.maxFinancingAmountMin', { min: MIN_LOAN_AMOUNT }))
      .defined()
      .nullable(),

    ownedByBanner: yup.boolean().required().default(false),
  })

export type CustomBuydownFormValues = yup.InferType<ReturnType<typeof customBuydownSchema>>
